import { useMutation } from '@apollo/client/react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@optools/components/ui/alert-dialog';
import { Button } from '@optools/components/ui/button';
import { DELETE_MILESTONE } from '@optools/services/operator-gateway/milestones/mutations';
import { GET_MILESTONES } from '@optools/services/operator-gateway/milestones/queries';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export interface DeleteMilestoneDialogProps {
  guid: string;
  mediaId: string;
}

export function DeleteMilestoneDialog({ guid, mediaId }: DeleteMilestoneDialogProps) {
  const [deleteMilestone] = useMutation(DELETE_MILESTONE, {
    onCompleted: (data) => {
      const success = !!data.deleteMilestone;
      if (!success) {
        toast.error('Delete Milestone Failure', { duration: Infinity });
        return;
      }
      toast.success(`Deleted Milestone: ${guid}`);
    },
    refetchQueries: [{ query: GET_MILESTONES, variables: { mediaId } }],
  });

  const handleDeleteClick = () => {
    if (!mediaId || !guid) return;
    deleteMilestone({ variables: { mediaId, milestoneId: guid } });
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button size="icon" variant="destructive">
          <Trash2 />
          <span className="sr-only">Delete</span>
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogTitle>Delete Milestone</AlertDialogTitle>
        <AlertDialogDescription>Are you sure you want to delete:</AlertDialogDescription>
        <AlertDialogDescription>{guid}</AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={handleDeleteClick}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
